export const CONNECTION_STATES = {
  DISCONNECTED: 'DISCONNECTED',
  CONNECTING: 'CONNECTING',
  CONNECTED: 'CONNECTED',
  TALKING: 'TALKING',
  ERROR: 'ERROR',
};

export const QUICK_PROMPTS = [
  {
    id: 'training',
    label: 'Industrial Training',
    query: 'Tell me about the 6-week and 6-month industrial training programs offered by O7 Services.',
  },
  {
    id: 'products',
    label: 'Software Products',
    query: 'What software products and enterprise solutions does O7 Services develop?',
  },
  {
    id: 'tech-stack',
    label: 'Tech Stack & Courses',
    query: 'Which programming languages, frameworks, and AI/Cloud courses do you teach?',
  },
  {
    id: 'infra',
    label: 'Campus & Infrastructure',
    query: 'Show me details about your infrastructure and learning facilities.',
  },
  {
    id: 'contact',
    label: 'Contact & Locations',
    query: 'How can I contact O7 Services and where are your offices located?',
  },
];

export const PRESET_AVATARS = [
  {
    id: 'assistant-1',
    name: 'Gaurav',
    role: 'Chief Technology Officer',
    url: 'https://res.cloudinary.com/djx2edbwi/image/upload/v1787575956/gn0oytzda38hr8fq8g9x.jpg',
    preview: 'https://res.cloudinary.com/djx2edbwi/image/upload/v1787575956/gn0oytzda38hr8fq8g9x.jpg',
    voiceId: 'en-IN-PrabhatNeural',
  },
  {
    id: 'assistant-2',
    name: 'Marcus',
    role: 'Technical Advisor',
    url: 'https://static.vecteezy.com/system/resources/thumbnails/056/415/731/small/happy-young-man-smiling-portrait-studio-shot-white-sweater-guy-male-face-model-clean-image-photo-png.png',
    preview: 'https://static.vecteezy.com/system/resources/thumbnails/056/415/731/small/happy-young-man-smiling-portrait-studio-shot-white-sweater-guy-male-face-model-clean-image-photo-png.png',
    voiceId: 'en-US-GuyNeural',
  },
  {
    id: 'assistant-3',
    name: 'Maya',
    role: 'Academic Counselor',
    url: 'https://img.magnific.com/free-photo/close-up-confident-corporate-woman-professional-entrepreneur-smiling-cross-arms-chest-smiling-enthusiastic-standing-white-background_1258-85600.jpg?semt=ais_hybrid&w=740&q=80',
    preview: 'https://img.magnific.com/free-photo/close-up-confident-corporate-woman-professional-entrepreneur-smiling-cross-arms-chest-smiling-enthusiastic-standing-white-background_1258-85600.jpg?semt=ais_hybrid&w=740&q=80',
    voiceId: 'en-US-JennyNeural',
  },
];

export const VOICE_OPTIONS = [
  { id: 'en-IN-PrabhatNeural', name: 'Prabhat (English - IN)' },
  { id: 'en-IN-NeerjaNeural', name: 'Neerja (English - IN)' },
  { id: 'en-US-JennyNeural', name: 'Jenny (English - US)' },
  { id: 'en-US-GuyNeural', name: 'Guy (English - US)' },
];

export const DEFAULT_CONFIG = {
  didUrl: process.env.REACT_APP_DID_URL || 'https://api.d-id.com',
  didKey: process.env.REACT_APP_DID_KEY || 'bzdzZXJ2aWNlczAyNkBnbWFpbC5jb20:1afOBeYfzAuB3kdsFyZFw',
  defaultVoice: process.env.REACT_APP_VOICE_ID || 'en-IN-PrabhatNeural',
  cloudinaryUrl: process.env.REACT_APP_CLOUDINARY_URL || 'https://api.cloudinary.com/v1_1/djx2edbwi/image/upload',
  serverUrl: process.env.REACT_APP_SERVER_URL || 'http://192.168.10.145:6006/gemini',
};
